/* jshint node:true */
'use strict';

var React = require('react');
var moment = require('moment');
var utils = require('../../../helpers/utils/index.js');

var TableBody = React.createClass({
    render: function(){
        
        var data = (this.props.data || []).slice(0,5);
        var tableRows = [];
        var classNames = {
            "W" : "win",
            "L" : "loss",
            "D" : ''
        };
        
        data.map(function(game, i){
            var gameResult = null;
            if(!this.props.head2head){
                gameResult = (
                    <td className={classNames[game.result]}>{game.result}</td>
                );
            }
            
            tableRows.push(
                <tr key={'game.'+i}>
                    {gameResult}
                    <td>
                        <a target="_blank" href={game.home.url}>
                            <span className="long-name">{game.home.name || game.home.abbreviation}</span>
                            <abbr>{game.home.abbreviation}</abbr>
                        </a>
                    </td>
                    <td className="logo">
                        <a target="_blank" href={game.home.url}><img src={utils.getImageUrl(game.home.logo)} /></a>
                    </td>
                    <td>
                        <a href={game.url}>{game.score}</a>
                    </td>
                    <td className="logo">
                        <a target="_blank" href={game.away.url}><img src={utils.getImageUrl(game.away.logo)} /></a>
                    </td>
                    <td>
                        <a target="_blank" href={game.away.url}><span className="long-name">{game.away.name ||  game.away.abbreviation}</span><abbr>{game.away.abbreviation}</abbr></a>
                    </td>
                    <td>{moment(game.date.replace('Z','')).utcOffset(0).format('Do MMM, YYYY')}</td>
                    <td>{game.league}</td>
                </tr>    
            );
        }.bind(this));
        
        return (
            <tbody>
                {tableRows}
            </tbody>
        );
    }
});

var MatchHistory = React.createClass({

    displayName: 'MatchHistory',
    
    getTeamName: function(data){
        var name = '';
        try {
            name = data[0].home.name;
        } catch (e) {}
        return name;
    },

    render: function () {

        var data = this.props.data || [];
        var team = this.props.team;
        var teamName;
        var teamLogo;
        
        if(this.props.head2head){
            teamName = this.getTeamName(data);
            teamLogo = utils.getImageUrl(data && data[0] && data[0].home.logo);
        }else{
            teamName = team.name;
            teamLogo = team.logo;
        }
        
        /* react wraps a span around the word so lets force it as it breaks the css*/
        var sDisplayTitle = this.props.head2head ? 'Head To Head Record' : '<img src="' + (utils.getImageUrl(teamLogo)) + '" />' + teamName + ' Form';
        var MatchHistoryView = null;
        
        MatchHistoryView = (
            <div className={"sub-module last-games soccer" + (this.props.head2head ? ' head-to-head'  :'')}>
            	<header className="">
            		<h1 dangerouslySetInnerHTML={{__html:sDisplayTitle}}></h1>
            	</header>
            	<div className="content" style={{overflowX:'auto'}}>
            		<table data-fix-cols="0" data-behavior="responsive_table">
            			<thead>
            				<tr>
            					<th colSpan={this.props.head2head ? "5" : "6"}>LAST FIVE GAMES</th>
            					<th>DATE</th>
            					<th>COMPETITION</th>
            				</tr>
            			</thead>
                        {this.props.data.length ? <TableBody head2head={this.props.head2head} data={this.props.data} /> : <tbody><tr><td colSpan="8">No data available</td></tr></tbody>}
            		</table>
            	</div>
            </div>
        );

        return MatchHistoryView;
    }
});

module.exports = MatchHistory;





/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/components/rugby/game/MatchHistory.jsx
 **/